<template>
  <div style="width: 100%;overflow: hidden;display: flex" :style="{height:height+'px',fontFamily: option.attribute.fontFamily}">
    <div v-for="(item, index) in numTops" :key="index" style="position: relative;height: 100%;flex:1">
      <div :style="{transition:'all 2s ease-in-out',top: '-' + item.top + 'px'}" style="position: absolute;width: 100%;">
        <div style="height: 100%;width: 100%;text-align: center;box-sizing: border-box" v-for="(item2, index2) in numList" :key="index2"
             :style="{padding:option.attribute.padding+'px',lineHeight:height-option.attribute.padding*2+'px'}">
          <div :style="{fontSize: option.attribute.fontSize + 'px',color: option.attribute.color,backgroundColor:option.attribute.bgColor,
               borderColor:option.attribute.borderColor,borderRadius: option.attribute.borderRadius + 'px'}">{{ item2 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";

export default {
  name: "cpt-rect-num",
  props: {
    option: Object,
    height:Number,
    components: Array, current: Object
  },
  data() {
    return {
      uuid: null,
      numTops: [],
      numList: ['.', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, ','],
      newData:"",
      jsFunFlag:false,
      cptData:"",
    }
  },
  computed:{
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    'option.attribute': {
      handler(obj) {
         this.processData(this.option.cptDataForm,this.newData,this.jsFunFlag);
      },
      deep: true,
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }

  },
  methods: {
  refreshCptData(cptDataForm = this.option.cptDataForm,paras) {
    pollingRefresh(this.uuid, cptDataForm, ()=>this.loadData(cptDataForm,paras),this.components)
  },
  loadData(cptDataForm,paras) {
    const that = this;
    getDataJson(cptDataForm,paras,(res)=> {
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        that.processData(cptDataForm,that.newData,that.jsFunFlag)
        // const arr = []
        // const strArray = res && res.value ?  res.value.split('') : '';
        // for (let i = 0; i < strArray.length; i++) {
        //   const val = strArray[i]
        //   arr.push({ num: val, top: 0 })
        //   if(this.option.attribute.showSeparator)
        //   if(i !== strArray.length-1 && ((strArray.length - i - 1) % 3) === 0){
        //     arr.push({ num: ',', top: 0 })
        //   }
        // }
        // that.numTops = arr;
        // this.scroll();
      })
  },
  processData(cptDataForm,res,jsFunFlag,isFromGrid){
    // 第一层判断 如果选择数据集
    if(cptDataForm.dataSource == '4') {
          if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

      // 第二层判断 ，如果没有配转换脚本
      if(jsFunFlag) { // 没有全部配置映射字段
          //判断此控件在九宫格里面就不请求数据
          if(hasNonEmptyValues(this.option.attribute.cptTableData)) {
            console.log(res,'res')
            const dataKey = this.option.attribute.cptTableData;
          // 创建一个新的数组用于存储结果
            let newres = [];
            let newObj = {...res[0]};
          // 如果dataKey中的value有值并且在newObj对象中有对应的值
            // if (dataKey[0].value && newObj[dataKey[0].value]) {
              newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            // }
            newres.push(newObj);
            console.log(newres,'新数组');
            this.cptData = newres[0]; 
         }
        } else { // 如果配置了转换脚本
          this.cptData = res;
        }
    } else { // 不是数据集类型，是静态数据
      this.cptData = res;
    }
     this.ExecutMethod(this.cptData)
    },
    ExecutMethod(res) {
      const that = this;
      let strValue;
      // 检查 res.value 是否存在且为 number 类型
      if (res && typeof res.value === 'number') {
        // 将 res.value 转换为 string
        strValue = String(res.value);
      } else if (res && res.value) {
        // 如果 res.value 已经是 string 或其他非 number 类型，直接使用其值
        strValue = res.value;
      }
      const arr = []
      const strArray = strValue ?  strValue.split('') : '';
      for (let i = 0; i < strArray.length; i++) {
        const val = strArray[i]
        arr.push({ num: val, top: 0 })
        if(this.option.attribute.showSeparator)
        if(i !== strArray.length-1 && ((strArray.length - i - 1) % 3) === 0){
          arr.push({ num: ',', top: 0 })
        }
      }
      that.numTops = arr;
      this.scroll(); 
    },
    scroll() {
      const that = this;
      this.numTops.forEach((item, index) => {
        setTimeout(() => {
          if('.' === item.num){
            item.top = 0
          }else if(',' === item.num){
            item.top = that.height * 11
          }else{
            item.top = (parseInt(item.num)+1) * that.height
          }
        }, index * 300)
      })
    },
  }
}
</script>

<style scoped>
</style>
